export default __webpack_public_path__ + "static/solutions-7-6878ef55110545fd87a23bb80a46349d.webp";